import React from "react";
import "./style.scss";

const AppFooter = () => {
  return (
    <div className="footer">
      <p>Copyright © {new Date().getFullYear()} Shree Maruti Integrated Logistics Limited.</p>
    </div>
  );
};

export default AppFooter;
